<template>
  <div class="cont" style="padding:62px 53px">
    <div class="title">
      <div class="title_name"></div>
    </div>

    <div class="clear" style="margin-bottom:37px">
      <div class="img_cont img_cont_ehv clear" style="margin-right:37px ;" @click="gotoDetail('DOT51EHV')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      <div class="img_cont img_cont_two clear" @click="gotoDetail('DOT51')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      <div class="img_cont img_cont_four clear" style="margin-right:38px;margin-top:38px" @click="gotoDetail('DOT4LV')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      <div class="img_cont img_cont_three clear" style="margin-right:38px;margin-top:38px" @click="gotoDetail('DOT4')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      <div class="img_cont img_cont_five clear" style="margin-top:38px;width:450px"  @click="gotoDetail('DOTDUR')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      <div class="img_cont img_cont_one clear" style="margin-right:18px ;margin-top:38px;"  @click="gotoDetail('328')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      



      <!-- <div class="img_cont img_cont_one clear" style="margin-right:37px ;margin-top:38px"  @click="gotoDetail('328')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>
      
      <div class="img_cont img_cont_two clear" @click="gotoDetail('DOT51')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_three clear" style="margin-right:37px;margin-top:38px" @click="gotoDetail('DOT4')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_three img"></div>
        <div style="float:left;width:200px">
          <div class="img_four img"></div>
        </div>
      </div>

      <div class="img_cont img_cont_four clear" style="margin-top:38px" @click="gotoDetail('DOT4LV')" >
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div>

      <div class="img_cont img_cont_five clear" style="margin-right:37px ;margin-top:38px;width:430px"  @click="gotoDetail('DOTDUR')">
        <div class="img_one img"></div>
        <div class="img_two img"></div>
        <div class="img_desc"></div>
      </div> -->

    </div>


  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain"
    };
  },
  methods: {
    gotoDetail( id ){
      // console.log( id )
      this.$router.push('/variousproducts/brakeOil/' + id )

    }
  }
};
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after { 
  display: block;
  clear: both;
  content: '';
}

.title { 
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background: url('~@/assets/image/variousproducts/brakeOil/img21.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 41px 42px 39px 42px; 
  box-sizing: border-box;
}

.title_name {
  width: 86px;
  height: 28px;
  background: url('~@/assets/image/variousproducts/brakeOil/img22.png');
  background-repeat: no-repeat;
  background-size: contain;
}


.img_cont {
  width: 410px;
  height: 103px;
  float: left;
  cursor pointer
}
  .img{
    background-repeat: no-repeat;
    background-size: cover;
    float: left;
  }
.img_cont_one
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeOil/img1.png');
    margin-right:5px;
  }
  /* 对应 gotoDetail('328')：容器占 136px 宽，图片等比缩放并居中显示，不平铺 */
  .img_two{
    width: 136px;             /* 位置占位宽度（容器占 136px） */
    height: 100px;            /* 高度与整行其他元素对齐 */
    background: url('~@/assets/image/variousproducts/brakeOil/328.png') no-repeat center; /* 一次性设置背景，不重复、居中 */
    background-size: contain; /* 等比缩放完整显示，不裁剪 */
    margin-right:6px;         /* 与右侧下一个元素的间距 */
  }
  .img_three{
    width: 120px;
    height: 23px;
    background: url('~@/assets/image/variousproducts/brakeOil/img3.png');
    margin-bottom:8px
  }
  .img_four{
    width: 165px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakeOil/img4.png');
  }
  /* 对应 328 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeOil/desc/328.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
.img_cont_ehv
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeOil/img5.png');
    margin-right:5px;
  }
  /* 对应 gotoDetail('DOT51EHV')：容器占 136px 宽，图片等比缩放并居中显示，不平铺（暂复用 DOT51 文字图） */
  .img_two{
    width: 136px;             /* 位置占位宽度（容器占 136px） */
    height: 100px;            /* 高度与整行其他元素对齐 */
    background: url('~@/assets/image/variousproducts/brakeOil/DOT51EHV.png') no-repeat center; /* 一次性设置背景，不重复、居中 */
    background-size: contain; /* 等比缩放完整显示，不裁剪 */
    margin-right:6px;         /* 与右侧下一个元素的间距 */
  }
  .img_three{
    width: 80px;
    height: 18px;
    background: url('~@/assets/image/variousproducts/brakeOil/img7.png');
    margin-bottom: 11px
  }
  .img_four{
    width: 210px;
    height: 33px;
    background: url('~@/assets/image/variousproducts/brakeOil/img8.png');
    background-size: contain;
  }
  /* 对应 DOT51EHV 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeOil/desc/DOT51EHV.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
.img_cont_two
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeOil/img5.png');
    margin-right:5px;
  }
  /* 对应 gotoDetail('DOT51')：容器占 136px 宽，图片等比缩放并居中显示，不平铺 */
  .img_two{
    width: 136px;             /* 位置占位宽度（容器占 136px） */
    height: 100px;            /* 高度与整行其他元素对齐 */
    background: url('~@/assets/image/variousproducts/brakeOil/DOT51.png') no-repeat center; /* 一次性设置背景，不重复、居中 */
    background-size: contain; /* 等比缩放完整显示，不裁剪 */
    margin-right:6px;         /* 与右侧下一个元素的间距 */
  }
  .img_three{
    width: 80px;
    height: 18px;
    background: url('~@/assets/image/variousproducts/brakeOil/img7.png');
    margin-bottom: 11px
  }
  .img_four{
    width: 210px;
    height: 33px;
    background: url('~@/assets/image/variousproducts/brakeOil/img8.png');
    background-size: contain;
  }
  /* 对应 DOT51 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeOil/desc/DOT51.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
.img_cont_three 
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeOil/img9.png');
    margin-right:5px;
  }
  /* 对应 gotoDetail('DOT4')：容器占 136px 宽，图片等比缩放并居中显示，不平铺 */
  .img_two{
    width: 136px;             /* 位置占位宽度（容器占 136px） */
    height: 100px;            /* 高度与整行其他元素对齐 */
    background: url('~@/assets/image/variousproducts/brakeOil/DOT4.png') no-repeat center; /* 一次性设置背景，不重复、居中 */
    background-size: contain; /* 等比缩放完整显示，不裁剪 */
    margin-right:6px;         /* 与右侧下一个元素的间距 */
  }
  .img_three{
    width: 61px;
    height: 18px;
    background: url('~@/assets/image/variousproducts/brakeOil/img11.png');
    margin-bottom: 11px
  }
  .img_four{
    width: 166px;
    height: 33px;
    background: url('~@/assets/image/variousproducts/brakeOil/img12.png');
  }
  /* 对应 DOT4 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeOil/desc/DOT4.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  } 
.img_cont_four
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeOil/img13.png');
    margin-right:5px;
  }
  /* 对应 gotoDetail('DOT4LV')：容器占 136px 宽，图片等比缩放并居中显示，不平铺 */
  .img_two{
    width: 136px;             /* 位置占位宽度（容器占 136px） */
    height: 100px;            /* 高度与整行其他元素对齐 */
    background: url('~@/assets/image/variousproducts/brakeOil/DOT4LV.png') no-repeat center; /* 一次性设置背景，不重复、居中 */
    background-size: contain; /* 等比缩放完整显示，不裁剪 */
    margin-right:6px;         /* 与右侧下一个元素的间距 */
  }
  .img_three{
    width: 96px;
    height: 18px;
    background: url('~@/assets/image/variousproducts/brakeOil/img15.png');
    margin-bottom: 11px
  }
  .img_four{
    width: 240px;
    height: 51px;
    background: url('~@/assets/image/variousproducts/brakeOil/img16.png');
  }
  /* 对应 DOT4LV 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeOil/desc/DOT4 LV.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  } 
.img_cont_five
  .img_one{
    width: 20px;
    height: 100px;
    background: url('~@/assets/image/variousproducts/brakeOil/img17.png');
    margin-right:5px;
  }
  /* 对应 gotoDetail('DOTDUR')：容器占 136px 宽，图片等比缩放并居中显示，不平铺 */
  .img_two{
    width: 136px;             /* 位置占位宽度（容器占 136px） */
    height: 100px;            /* 高度与整行其他元素对齐 */
    background: url('~@/assets/image/variousproducts/brakeOil/DUR.png') no-repeat center; /* 一次性设置背景，不重复、居中 */
    background-size: contain; /* 等比缩放完整显示，不裁剪 */
    margin-right:6px;         /* 与右侧下一个元素的间距 */
  }
  .img_three{
    width: 49px;
    height: 18px;
    background: url('~@/assets/image/variousproducts/brakeOil/img19.png');
    margin-bottom: 11px
  }
  .img_four{
    width: 256px;
    height: 34px;
    background: url('~@/assets/image/variousproducts/brakeOil/img20.png');
  }
  /* 对应 DOTDUR 描述图 */
  .img_desc{
    float: left;
    width: 218px;
    height: 95px;
    background: url('~@/assets/image/variousproducts/brakeOil/desc/DUR.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  } 
</style>